import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

export const IngestCh99PdfBIZcoreTD = (formData, setLoading, setResult) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.ingestCh99PdfBIZcoreTD(formData);
    // The response may have leading spaces from streaming keep-alive.
    // Axios parses JSON automatically, but if it comes as string, parse it.
    let parsed = data;
    if (typeof data === 'string') {
      try { parsed = JSON.parse(data.trim()); } catch (e) { parsed = { data: null }; }
    }
    if (status === 201) {
      toast.success(parsed.message || "Ingestion completed");
      if (setResult) setResult(parsed.data || parsed);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: parsed });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const WipeCh99TablesBIZcoreTD = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.wipeCh99TablesBIZcoreTD();
    if (status === 201) {
      toast.success(data.message || "SC tables wiped");
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
